/**
 * OrbDocDownloadsSkillsSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocDownloadsSkillsSLDocScreen
 */

import { useOrbDocDownloadsSkillsSLDocScreenLogic } from '@/hooks/traits/useOrbDocDownloadsSkillsSLDocScreenLogic';
import type { OrbDocDownloadsSkillsSLDocScreenConfig } from '@/hooks/traits/useOrbDocDownloadsSkillsSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocDownloadsSkillsSLDocView as OrbDocDownloadsSkillsSLDocViewEntity } from '@app/shared';
import { OrbDocDownloadsSkillsSLDocBodyView } from '@/components/traits/OrbDocDownloadsSkillsSLDocBodyView';
import { OrbDocDownloadsSkillsSLDocFooterView } from '@/components/traits/OrbDocDownloadsSkillsSLDocFooterView';
import { OrbDocDownloadsSkillsSLDocHeaderView } from '@/components/traits/OrbDocDownloadsSkillsSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocDownloadsSkillsSLDocScreenViewProps {
  config?: Partial<OrbDocDownloadsSkillsSLDocScreenConfig>;
}

export function OrbDocDownloadsSkillsSLDocScreenView({ config: propsConfig }: OrbDocDownloadsSkillsSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocDownloadsSkillsSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocDownloadsSkillsSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocDownloadsSkillsSL" trait="OrbDocDownloadsSkillsSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocDownloadsSkillsSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocDownloadsSkillsSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocDownloadsSkillsSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocDownloadsSkillsSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocDownloadsSkillsSLDocScreenView;
